
import { useState, useEffect } from 'react';

export const useIsIOS = () => {
  const [isIOS, setIsIOS] = useState(false);
  
  useEffect(() => {
    const checkPlatform = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      setIsIOS(/iphone|ipad|ipod/.test(userAgent) || 
              (userAgent.includes('mac') && 'ontouchend' in document));
    };
    
    checkPlatform();
  }, []);
  
  return isIOS;
};
